import { getJSON } from 'bv-fetch';

export default () => getJSON('/preferences/edit');
